import { useTranslation } from 'react-i18next'

import { useNewsOrder } from '../hooks/useNewsOrder'
import { NewsOrderCard } from './NewsOrderCard'

export function FormNewsOrder() {
  const { t } = useTranslation('panel')
  const { containerRef, newsOrder } = useNewsOrder()

  return (
    <div className="space-y-6 pb-4">
      <div className="space-y-2">
        <h2 className="text-2xl text-sky-700 font-semibold">
          {t('news.drawer_create_news.order.title')}
        </h2>

        <p className="text-base text-base-700">
          {t('news.drawer_create_news.order.subtitle')}
        </p>
      </div>

      <div className="flex flex-col flex-1 gap-4" ref={containerRef}>
        {newsOrder.map(({ slotId, itemId, item: news }, index) => (
          <div data-swapy-slot={slotId} key={slotId}>
            <div data-swapy-item={itemId} key={itemId} className="group/item">
              <NewsOrderCard key={itemId} position={index} news={news} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
